import { Meter } from '@cloudflare/kumo'
import { useTranslation } from '../../i18n'

interface EnrollProgressProps {
  /** 1-based position among the steps actually shown. */
  step: number
  /** Number of steps this enrollment will show (skipped steps excluded). */
  total: number
  /** Already-translated step name. */
  name: string
}

/** Meter plus "Step N of M · name". */
export function EnrollProgress({ step, total, name }: EnrollProgressProps) {
  const { t } = useTranslation()
  return (
    <div data-testid="enroll-progress">
      <Meter
        label={t('enroll.progress', { step, total, name })}
        value={step}
        max={total}
        showValue={false}
      />
    </div>
  )
}
